import React from "react";
import ContactForm from "./ContactForm";
import githubIcon from "../../public/images/github-orange.svg";
import twitterIcon from "../../public/images/twitter.svg";
import linkedinIcon from "../../public/images/linkedin.svg";
import mediumIcon from "../../public/images/medium-icon.svg";
import resume from '../../public/images/medium-icon.svg';


const Contact = () => {
  return (
    <main className="contact">
      <section className="contact-container">
        {/* <p>Thanks for stopping by, please reach out if you'd like to chat!</p> */}
        <div>
          {/* <p className="contact-label">You can contact me here:</p> */}
          <ContactForm email="swetha.blue.sky@gmail.com" />
          <div>
            <ul id="social-list">
              <li id="github-icon" className="social-icon">
                <a href="https://github.com/SwethaMuralidharan/">
                  <img src={githubIcon} alt="Github Account" />
                </a>
              </li>
              <li id="linkedin-icon" className="social-icon">
                <a href="https://www.linkedin.com/in/swetha-muralidharan/">
                  <img src={linkedinIcon} alt="Linked In Profile" />
                </a>
              </li>
              <li id="twitter-icon" className="social-icon">
                <a href="https://twitter.com/Swethasky">
                  <img src={twitterIcon} alt="Twittert" />
                </a>
              </li>
              {/* <li id="twitter-icon" className="social-icon">
                <a href="images/resume.pdf" target="_blank">
                  <img src={resume} alt="Twittert" />
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/components/Contact.js
 **/